/* Tranquil theme JS – small, dependency-free */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    return (fmt || '£{{amount}}').replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- Toast + cart count ---------- */
  function showToast(msg) {
    var t = $('#CartToast'); if (!t) return;
    if (msg) $('.toast__msg', t).textContent = msg;
    t.hidden = false; clearTimeout(t._h);
    t._h = setTimeout(function () { t.hidden = true; }, 5000);
  }
  function refreshCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
    }).catch(function () {});
  }

  /* ---------- Product page ---------- */
  $$('[data-product]').forEach(function (root) {
    var dataEl = $('script[type="application/json"][data-product-json]', root);
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var form = $('form[data-product-form]', root);
    if (!form) return;
    var payWrap = $('[data-payment-wrap]', root);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-add-button]', root);
    var stockEl = $('[data-stock]', root);
    var notifyEl = $('[data-notify]', root);
    var notifyVariant = $('[data-notify-variant]', root);
    var preorderProp = $('[data-preorder-prop]', root);
    var priceEl = $('[data-price]', root);
    var skuEl = $('[data-sku]', root);
    var stickyBtn = $('[data-sticky-add]');

    function current() {
      var opts = $$('[data-option-index]', root).map(function (fs) {
        var c = $('input:checked', fs) || $('select', fs);
        return c ? c.value : null;
      });
      if (!opts.length) return data.variants[0];
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }

    function state(v) {
      if (!v) return 'unavailable';
      if (!v.available) return 'soldout';
      if (data.preorderEnabled && v.inventory_management === 'shopify' && v.inventory_quantity <= 0) return 'preorder';
      return 'instock';
    }

    function render() {
      var v = current();
      var s = state(v);
      if (v) {
        idInput.value = v.id;
        if (notifyVariant) notifyVariant.value = v.title + (v.sku ? ' (SKU ' + v.sku + ')' : '');
        if (priceEl) {
          var html = '<span class="price__now">' + money(v.price, data.moneyFormat) + '</span>';
          if (v.compare_at_price > v.price) html += '<span class="price__was">' + money(v.compare_at_price, data.moneyFormat) + '</span>';
          html += '<span class="price__vat">inc. VAT</span>';
          priceEl.innerHTML = html;
        }
        if (skuEl) skuEl.textContent = v.sku ? 'SKU ' + v.sku : '';
        if (v.featured_media_id) showMedia(String(v.featured_media_id));
        if (history.replaceState && data.variants.length > 1) {
          var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
        }
      }
      var label = s === 'preorder' ? data.labels.preorder : s === 'instock' ? data.labels.add : s === 'soldout' ? data.labels.soldout : data.labels.unavailable;
      btn.textContent = label; btn.disabled = (s === 'soldout' || s === 'unavailable');
      if (stickyBtn) { stickyBtn.textContent = label; stickyBtn.disabled = btn.disabled; }
      if (preorderProp) preorderProp.disabled = s !== 'preorder';
      if (payWrap) payWrap.hidden = s !== 'instock';
      if (stockEl) {
        stockEl.className = 'stock' + (s === 'preorder' ? ' stock--preorder' : (s === 'soldout' || s === 'unavailable') ? ' stock--soldout' : '');
        stockEl.innerHTML = s === 'preorder' ? '<span><strong>Available to pre-order</strong>' + data.preorderMessage + '</span>'
          : s === 'instock' ? '<span><strong>In stock</strong>' + data.labels.instockNote + '</span>'
          : s === 'soldout' ? '<span><strong>Currently sold out</strong>Leave your email below and we’ll let you know the moment it’s back.</span>'
          : '<span><strong>This combination isn’t available</strong>Try another option.</span>';
      }
      if (notifyEl) notifyEl.hidden = s !== 'soldout';
    }

    $$('[data-option-index] input, [data-option-index] select', root).forEach(function (el) { el.addEventListener('change', render); });

    /* gallery */
    function showMedia(id) {
      var thumb = $('[data-thumb="' + id + '"]', root);
      if (thumb) thumb.click();
    }
    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('[data-main-image]', root);
        main.src = t.dataset.src; main.srcset = t.dataset.srcset || ''; main.alt = t.dataset.alt || '';
        $$('[data-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      });
    });

    /* qty */
    $$('[data-qty]', root).forEach(function (q) {
      var input = $('input', q);
      $$('button', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(input.value || '1', 10) + (b.dataset.step === 'up' ? 1 : -1);
          input.value = Math.max(1, n);
        });
      });
    });

    /* ajax add */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var orig = btn.textContent; btn.disabled = true; btn.textContent = 'Adding…';
      fetch(window.theme.routes.cart_add_url + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { showToast(state(current()) === 'preorder' ? 'Pre-order added to your basket' : 'Added to your basket'); refreshCount(); })
        .catch(function (err) { showToast((err && (err.description || err.message)) || 'Sorry, that couldn’t be added.'); })
        .finally(function () { btn.disabled = false; btn.textContent = orig; render(); });
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : btn.click(); });
      var bar = stickyBtn.closest('.sticky-buy');
      if ('IntersectionObserver' in window && bar) {
        new IntersectionObserver(function (en) { var e = en[0]; bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); }).observe(btn);
      }
    }
    render();
  });

  /* ---------- Product finder ---------- */
  $$('[data-finder]').forEach(function (f) {
    var chosen = { url: null, sizes: false, size: '' };
    var go = $('[data-finder-go]', f);
    var sizeStep = $('[data-finder-size]', f);
    $$('[data-finder-type]', f).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('[data-finder-type]', f).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        chosen.url = c.dataset.url; chosen.sizes = c.dataset.sizes === 'true'; chosen.size = '';
        $$('[data-finder-sizeval]', f).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        sizeStep.hidden = !chosen.sizes;
        go.disabled = false; update();
      });
    });
    $$('[data-finder-sizeval]', f).forEach(function (c) {
      c.addEventListener('click', function () {
        $$('[data-finder-sizeval]', f).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        chosen.size = c.dataset.finderSizeval; update();
      });
    });
    function update() {
      var hint = $('[data-finder-hint]', f);
      if (hint) hint.textContent = chosen.size ? 'Showing mounts that fit ' + $('[aria-pressed="true"][data-finder-sizeval]', f).textContent.trim() + ' screens.' : 'Tip: pick a screen size to narrow things down.';
    }
    go.addEventListener('click', function () {
      if (!chosen.url) return;
      location.href = chosen.url + (chosen.size ? '/' + chosen.size : '');
    });
  });

  /* ---------- Collection filters ---------- */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      location.search = params.toString();
    });
  });
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString();
    });
  });

  /* ---------- Cart page ---------- */
  $$('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () { input.form.submit(); });
  });
  var waBox = $('[data-wa-optin]');
  if (waBox) {
    var phone = $('[data-wa-phone]');
    var sync = function () { phone.closest('[data-wa-phone-wrap]').hidden = !waBox.checked; phone.required = waBox.checked; };
    waBox.addEventListener('change', sync); sync();
  }
})();
